import React, { useState, useEffect } from "react";
import { Badge, Button, Card, Container, Row, Col } from "react-bootstrap";
import videoApresentacao from '../assets/video/apresentacao.mp4';
import { useHistory } from 'react-router-dom';

function AjudaView() {
  // Cards de estatísticas para a seção de ajuda
  const statCards = [
    { value: '1', label: 'Vídeo Tutorial', icon: '🎥', color: '#43a047' }
  ];

  const whatsappNumber = '5519981590411';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  const history = useHistory();

  return (
    <div style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      {/* Header seguindo padrão */}
      <div style={{backgroundColor: '#43a047', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500'}}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button variant="outline-light" size="sm" style={{borderColor: 'white', color: 'white', marginRight: 12}} onClick={() => history.push('/admin/home')}>
              ← Voltar
            </Button>
            <span>Ajuda</span>
          </div>
          <Badge bg="primary" className="px-3 py-2">
            Central de suporte
          </Badge>
        </div>
      </div>

        <style jsx>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
        {/* Cards de Estatísticas */}
        <Row className="mb-3 mt-3 ml-1 mr-3">
          {statCards.map((stat, index) => (
            <Col xl={3} lg={4} md={6} key={index} className="mb-3">
              <Card className="text-center h-100" style={{backgroundColor: stat.color, color: 'white'}}>
                <Card.Body className="py-3">
                  <div style={{fontSize: '2rem', marginBottom: '8px'}}>{stat.icon}</div>
                  <h4 className="mb-1">{stat.value}</h4>
                  <small>{stat.label}</small>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Seção Principal - Vídeo de Apresentação */}
        <div className="bg-white mb-3 ml-3 mr-3" style={{border: '1px solid #dee2e6'}}>
          <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
            <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>🎥 Apresentação da ferramenta</h6>
          </div>
          <div className="p-3">
            <Row>
              <Col lg={8} className="mb-3">
                <div style={{position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden'}}>
                  <iframe 
                    src={videoApresentacao} 
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      border: 'none',
                      borderRadius: '8px'
                    }}
                    allowFullScreen={true}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="h-100 d-flex flex-column">
                  <h5 style={{color: '#43a047', marginBottom: '16px'}}>📚 Sobre este vídeo</h5>
                  <p style={{fontSize: '14px', color: '#6c757d', lineHeight: '1.5', marginBottom: '16px'}}>
                    Este vídeo apresenta as principais funcionalidades da ferramenta, incluindo:
                  </p>
                  <ul style={{fontSize: '13px', color: '#6c757d', paddingLeft: '20px', marginBottom: '16px'}}>
                    <li>Como configurar automações</li>
                    <li>Gerenciamento de agendamentos</li>
                    <li>Personalização de mensagens</li>
                    <li>Monitoramento de resultados</li>
                  </ul>
                  <div className="mt-auto">
                    <small className="text-muted">
                      <strong>💡 Dica:</strong> Assista em tela cheia para melhor experiência
                    </small>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Seção de Links Úteis */}
        <div className="bg-white mb-3" style={{border: '1px solid #dee2e6'}}>
          <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
            <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>🔗 Links úteis</h6>
          </div>
          <div className="p-3">
            <Row>
              <Col md={6} className="mb-3">
                <Card className="h-100" style={{border: '1px solid #e9ecef'}}>
                  <Card.Body className="text-center py-4">
                    <div style={{fontSize: '2.5rem', marginBottom: '12px'}}>📖</div>
                    <h6 style={{color: '#43a047', marginBottom: '8px'}}>Documentação</h6>
                    <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '16px'}}>
                      Acesse a documentação completa da ferramenta
                    </p>
                    <Button 
                      variant="outline-success" 
                      size="sm"
                      style={{borderColor: '#43a047', color: '#43a047'}}
                    >
                      Acessar docs
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} className="mb-3">
                <Card className="h-100" style={{border: '1px solid #e9ecef'}}>
                  <Card.Body className="text-center py-4">
                    <div style={{fontSize: '2.5rem', marginBottom: '12px'}}>💬</div>
                    <h6 style={{color: '#43a047', marginBottom: '8px'}}>Suporte</h6>
                    <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '16px'}}>
                      Entre em contato com nossa equipe de suporte
                    </p>
                    <Button 
                      variant="outline-success" 
                      size="sm"
                      style={{borderColor: '#43a047', color: '#43a047'}}
                      onClick={() => window.open(whatsappUrl, '_blank')}
                    >
                      Falar com suporte
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        {/* Seção de FAQ */}
        <FAQSection />
    </div>
  );
}

// Componente FAQ com Accordion Interativo
const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      icon: "🤖",
      category: "Automações",
      question: "Como ativar uma automação?",
      answer: "Acesse a página de Automações, encontre a automação desejada e ative o switch correspondente. Configure os parâmetros necessários como agenda, procedimentos, status e horário, depois clique em 'Adicionar' para salvar a configuração."
    },
    {
      icon: "💬",
      category: "Mensagens",
      question: "Quais variáveis posso usar nas mensagens?",
      answer: "Você pode usar: $nomePaciente, $nomeProcedimento, $nomeMedico, $nomeDiaDaSemana, $dataAgendamento, $horarioAgendamento e $link para personalizar suas mensagens automaticamente."
    },
    {
      icon: "📊",
      category: "Dashboard",
      question: "Como interpretar os gráficos do dashboard?",
      answer: "O dashboard mostra envios do mês atual, total de mensagens, automações ativas e instâncias WhatsApp conectadas. O gráfico exibe envios diários com estatísticas de total, média, pico máximo e envios de hoje."
    },
    {
      icon: "📱",
      category: "WhatsApp",
      question: "Como escolher qual WhatsApp usar para cada tipo de mensagem?",
      answer: "Na página de Mensagens, cada seção tem um seletor 'WhatsApp 1', 'WhatsApp 2', 'WhatsApp 3' ou 'WhatsApp 4' no canto superior direito. Você pode escolher qual instância será usada para cada tipo de mensagem (confirmações, lembretes, etc.)."
    },
    {
      icon: "✨",
      category: "Formatação",
      question: "Como formatar textos nas mensagens?",
      answer: "Use *TEXTO* para negrito, _TEXTO_ para itálico e ~TEXTO~ para texto tachado. Exemplo: *Olá Dr. João* aparecerá como texto em negrito no WhatsApp."
    },
    {
      icon: "🎂",
      category: "Aniversários",
      question: "Posso enviar imagens nas mensagens de aniversário?",
      answer: "Sim! Na configuração de aniversário, você pode escolher entre 'Texto' ou 'Imagem'. Para imagem, faça upload de um arquivo PNG, GIF ou JPEG que será enviado automaticamente."
    },
    {
      icon: "📋",
      category: "Mensagens Prontas",
      question: "Como usar as mensagens prontas?",
      answer: "Na página Mensagens Prontas, digite sua mensagem e clique 'Adicionar'. Use Ctrl+Enter para adicionar rapidamente. Clique em 'Copiar' para usar a mensagem em outros lugares."
    },
    {
      icon: "🔍",
      category: "Envios",
      question: "Como filtrar e pesquisar envios?",
      answer: "Na página Envios, defina período (data início/fim), selecione profissional e tipo de mensagem. Clique 'Pesquisar' para ver resultados. Os cards mostram estatísticas como total, contatos únicos e média por dia."
    },
    {
      icon: "⏰",
      category: "Horários",
      question: "Posso definir horários específicos para cada automação?",
      answer: "Sim! Para confirmações, lembretes e pré-cadastros você define o 'Horário de início dos envios'. Para aniversários, as mensagens são enviadas automaticamente às 08:00 todos os dias."
    },
    {
      icon: "🎯",
      category: "Configuração",
      question: "Como funciona a configuração por 'dias antes'?",
      answer: "Selecione quando enviar em relação ao agendamento: 'No dia', '1 dia antes', '2 dias antes', etc. Combine com o horário de envio para criar lembretes antecipados personalizados."
    },
    {
      icon: "📄",
      category: "Tipos de Mensagem",
      question: "Quais tipos de mensagem posso configurar?",
      answer: "O sistema suporta: Confirmação de agendamento, Pré-cadastro, Pré-consulta, Lembrete, Questionário, Aniversário, Texto, PDF, Resumo de ciclo, Laudo Espermograma, GED (Anexos) e Nota Fiscal."
    },
    {
      icon: "🔗",
      category: "Links",
      question: "Como funcionam os links nas mensagens?",
      answer: "Use a variável $link em mensagens de confirmação, pré-cadastro e pré-consulta. O sistema gera automaticamente links únicos para cada paciente. Para pré-cadastro use também $dataValidadeLink."
    },
    {
      icon: "📈",
      category: "Relatórios",
      question: "Como ver estatísticas detalhadas dos envios?",
      answer: "No Dashboard veja visão geral com gráfico mensal. Na página Envios, após pesquisar, veja cards com total de envios, contatos únicos, tipos diferentes e média por dia do período selecionado."
    },
    {
      icon: "🛡️",
      category: "Segurança",
      question: "As configurações são salvas automaticamente?",
      answer: "Sim! Clique 'Salvar' em cada mensagem ou 'Adicionar' nas automações. Você receberá confirmação visual de sucesso. O switch de habilitação também salva automaticamente ao ser alterado."
    },
    {
      icon: "📞",
      category: "Contatos",
      question: "Como o sistema identifica os contatos?",
      answer: "O sistema usa os dados dos pacientes cadastrados no seu sistema. Na página Envios você pode ver qual contato recebeu cada mensagem, filtrar por profissional e acompanhar o histórico completo."
    },
    {
      icon: "🔄",
      category: "Funcionamento",
      question: "As automações funcionam 24 horas por dia?",
      answer: "Sim! O sistema monitora continuamente e envia mensagens nos horários configurados, 24/7. Veja o status no Dashboard - deve mostrar 'Sistema Operacional' e 'WhatsApp Conectado'."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="bg-white mb-3 ml-3 mr-3" style={{border: '1px solid #dee2e6'}}>
      <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
        <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>❓ Perguntas frequentes</h6>
      </div>
      <div className="p-3">
        <div className="row">
          {faqs.map((faq, index) => (
            <div key={index} className="col-12 mb-2">
              <div 
                style={{
                  border: '1px solid #e9ecef',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  onClick={() => toggleAccordion(index)}
                  style={{
                    padding: '12px 16px',
                    background: activeIndex === index ? '#f8f9fa' : 'white',
                    cursor: 'pointer',
                    borderBottom: activeIndex === index ? '1px solid #e9ecef' : 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (activeIndex !== index) {
                      e.target.style.backgroundColor = '#f8f9fa';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeIndex !== index) {
                      e.target.style.backgroundColor = 'white';
                    }
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <span style={{fontSize: '1.2rem', marginRight: '8px'}}>{faq.icon}</span>
                      <div>
                        <Badge 
                          bg="light" 
                          text="dark" 
                          className="me-2" 
                          style={{fontSize: '10px'}}
                        >
                          {faq.category}
                        </Badge>
                        <span style={{color: '#495057', fontSize: '14px', fontWeight: '500'}}>
                          {faq.question}
                        </span>
                      </div>
                    </div>
                    <span 
                      style={{
                        color: '#43a047',
                        fontSize: '18px',
                        transform: activeIndex === index ? 'rotate(45deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      +
                    </span>
                  </div>
                </div>
                {activeIndex === index && (
                  <div 
                    style={{
                      padding: '16px',
                      backgroundColor: '#fafafa',
                      borderTop: '1px solid #e9ecef',
                      animation: 'fadeIn 0.3s ease'
                    }}
                  >
                    <p style={{
                      fontSize: '13px', 
                      color: '#6c757d', 
                      marginBottom: '0', 
                      lineHeight: '1.5'
                    }}>
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        {/* Rodapé do FAQ */}
        <div className="mt-4 pt-3" style={{borderTop: '1px solid #e9ecef'}}>
          <div className="text-center">
            <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '8px'}}>
              Não encontrou o que procurava?
            </p>
            <Button 
              variant="outline-success" 
              size="sm"
              style={{borderColor: '#43a047', color: '#43a047'}}
              onClick={() => window.open(whatsappUrl, '_blank')}
            >
              Falar com suporte
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AjudaView;